module.exports = __webpack_public_path__ + "images/avatars/female/21.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/female/21.png
// module id = F3zo
// module chunks = 118